
// // import React, { useEffect, useRef } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import './SplashScreen.css';

// // /**
// //  * SplashScreen Component
// //  * 
// //  * Displays a static image splash screen on app launch with:
// //  * - Static logo image (splash0125.png)
// //  * - Click-anywhere to skip to login
// //  * - Automatic navigation to login after 3 seconds
// //  * 
// //  * @component
// //  */
// // const SplashScreen = ({ onComplete }) => {
// //   const navigate = useNavigate();
// //   const navigationTimeoutRef = useRef(null);

// //   /**
// //    * Set up automatic navigation after 3 seconds
// //    */
// //   useEffect(() => {
// //     // Navigate to login after 3 seconds
// //     navigationTimeoutRef.current = setTimeout(() => {
// //       onComplete();
// //       navigate('/login');
// //     }, 3000);

// //     // Cleanup on unmount
// //     return () => {
// //       if (navigationTimeoutRef.current) {
// //         clearTimeout(navigationTimeoutRef.current);
// //       }
// //     };
// //   }, [navigate, onComplete]);

// //   /**
// //    * Handles click event to skip animation
// //    * Navigates immediately to login page
// //    */
// //   const handleClick = () => {
// //     // Clear pending timeout
// //     if (navigationTimeoutRef.current) {
// //       clearTimeout(navigationTimeoutRef.current);
// //     }
    
// //     // Update parent state first, then navigate
// //     onComplete();
// //     navigate('/login');
// //   };

// //   return (
// //     <div 
// //       className="splash-screen-container" 
// //       onClick={handleClick}
// //       role="button"
// //       aria-label="Click to skip splash screen"
// //       tabIndex={0}
// //       onKeyPress={(e) => {
// //         if (e.key === 'Enter' || e.key === ' ') {
// //           handleClick();
// //         }
// //       }}
// //     >
// //       {/* Static splash image */}
// //       <img
// //         src="/splash0125.png"
// //         alt="On-Screen Logo"
// //         className="splash-logo-image"
// //         aria-label="On-Screen splash logo"
// //       />

// //       {/* Skip hint (fades in after 0.5 second) */}
// //       <div className="skip-hint">
// //         Click anywhere to continue
// //       </div>
// //     </div>
// //   );
// // };

// // export default SplashScreen;

// import React, { useEffect, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './SplashScreen.css';

// /**
//  * SplashScreen Component
//  * 
//  * Displays a static image splash screen on app launch with:
//  * - Static logo image (splash0125.png)
//  * - Click-anywhere to skip
//  * - Automatic navigation after 3 seconds
//  * - Preserves the original URL (doesn't force /login)
//  * 
//  * @component
//  */
// const SplashScreen = ({ onComplete }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const navigationTimeoutRef = useRef(null);

//   /**
//    * Set up automatic navigation after 3 seconds
//    * Navigates to current path OR /login if on root
//    */
//   useEffect(() => {
//     navigationTimeoutRef.current = setTimeout(() => {
//       onComplete();
//       // Only navigate to /login if we're on the root path
//       // Otherwise, stay on the current URL (for EventAction, etc.)
//       if (location.pathname === '/') {
//         navigate('/login');
//       }
//       // For any other path, just hide splash and show the page
//     }, 3000);

//     // Cleanup on unmount
//     return () => {
//       if (navigationTimeoutRef.current) {
//         clearTimeout(navigationTimeoutRef.current);
//       }
//     };
//   }, [navigate, onComplete, location]);

//   /**
//    * Handles click event to skip animation
//    * Navigates immediately to appropriate page
//    */
//   const handleClick = () => {
//     // Clear pending timeout
//     if (navigationTimeoutRef.current) {
//       clearTimeout(navigationTimeoutRef.current);
//     }
    
//     // Update parent state first, then navigate if needed
//     onComplete();
//     // Only navigate to /login if we're on the root path
//     if (location.pathname === '/') {
//       navigate('/login');
//     }
//     // For any other path, just hide splash
//   };

//   return (
//     <div 
//       className="splash-screen-container" 
//       onClick={handleClick}
//       role="button"
//       aria-label="Click to skip splash screen"
//       tabIndex={0}
//       onKeyPress={(e) => {
//         if (e.key === 'Enter' || e.key === ' ') {
//           handleClick();
//         }
//       }}
//     >
//       {/* Static splash image */}
//       <img
//         src="/splash0125.png"
//         alt="On-Screen Logo"
//         className="splash-logo-image"
//         aria-label="On-Screen splash logo"
//       />

//       {/* Skip hint (fades in after 0.5 second) */}
//       <div className="skip-hint">
//         Click anywhere to continue
//       </div>
//     </div>
//   );
// };

// export default SplashScreen;


import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './SplashScreen.css';

/**
 * SplashScreen Component
 * 
 * Displays a static image splash screen on app launch with:
 * - Static logo image (splash0125.png)
 * - Click-anywhere to skip
 * - Automatic navigation after 3 seconds
 * - Preserves the original URL (doesn't force /login)
 * - Footer with Terms of Service and Privacy Policy links
 * 
 * @component
 */
const SplashScreen = ({ onComplete }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationTimeoutRef = useRef(null);

  /**
   * Set up automatic navigation after 3 seconds
   * Navigates to current path OR /login if on root
   */
  useEffect(() => {
    navigationTimeoutRef.current = setTimeout(() => {
      onComplete();
      // Only navigate to /login if we're on the root path
      // Otherwise, stay on the current URL (for EventAction, etc.)
      if (location.pathname === '/') {
        navigate('/login');
      }
      // For any other path, just hide splash and show the page
    }, 3000);

    // Cleanup on unmount
    return () => {
      if (navigationTimeoutRef.current) {
        clearTimeout(navigationTimeoutRef.current);
      }
    };
  }, [navigate, onComplete, location]);

  /**
   * Handles click event to skip animation
   * Navigates immediately to appropriate page
   */
  const handleClick = (e) => {
    // Don't trigger if clicking on footer links
    if (e.target.tagName === 'A') {
      return;
    }

    // Clear pending timeout
    if (navigationTimeoutRef.current) {
      clearTimeout(navigationTimeoutRef.current);
    }
    
    // Update parent state first, then navigate if needed
    onComplete();
    // Only navigate to /login if we're on the root path
    if (location.pathname === '/') {
      navigate('/login');
    }
    // For any other path, just hide splash
  };

  return (
    <div 
      className="splash-screen-container" 
      onClick={handleClick}
      role="button"
      aria-label="Click to skip splash screen"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick(e);
        }
      }}
    >
      {/* Static splash image */}
      <img
        src="/splash0125.png"
        alt="On-Screen Logo"
        className="splash-logo-image"
        aria-label="On-Screen splash logo"
      />

      {/* Skip hint (fades in after 0.5 second) */}
      <div className="skip-hint">
        Click anywhere to continue
      </div>

      {/* Footer with Terms of Service and Privacy Policy links */}
      <footer style={{
        position: 'absolute',
        bottom: '10px',
        left: '0',
        right: '0',
        textAlign: 'center',
        fontSize: '11px',
        color: 'rgba(61, 61, 56, 0.5)',
        pointerEvents: 'auto' // Allow clicks on links
      }}>
        <div>
          <Link 
            to="/termsofuse"
            onClick={(e) => e.stopPropagation()} // Prevent splash skip when clicking links
            style={{ 
              margin: '0 8px', 
              color: 'rgba(0, 102, 204, 0.7)', 
              textDecoration: 'none' 
            }}
          >
            Terms of Service
          </Link>
          <span style={{ color: 'rgba(61, 61, 56, 0.3)' }}>|</span>
          <Link 
            to="/privacypolicy"
            onClick={(e) => e.stopPropagation()} // Prevent splash skip when clicking links
            style={{ 
              margin: '0 8px', 
              color: 'rgba(0, 102, 204, 0.7)', 
              textDecoration: 'none' 
            }}
          >
            Privacy Policy
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default SplashScreen;